import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { ListingCategorySearchParams } from 'src/app/listing-catagories/listing-category-search-params.model';
import { ListingCategory } from 'src/app/listing-catagories/listing-category.model';
import { ListingCategoryService } from 'src/app/listing-catagories/listing-category.service';
import { ListingSubCategorySearchParams } from 'src/app/listing-catagories/listing-sub-category-search-params.model';
import { ListingSubCategory } from 'src/app/listing-catagories/listing-sub-category.model';
import { ListingSubCategoryService } from 'src/app/listing-catagories/listing-sub-category.service';
import { SocialMediaType } from 'src/app/profiles/shared/social-media-type';
import { TranslationService } from 'src/app/shared';
import { FormResponseDto } from '../../shared/dto/form-response.dto';
import { FormV2ElementResponseDto } from '../../shared/dto/form-v2-element-response.dto';
import { FormV2ElementTypeEnum } from '../../shared/dto/form-v2-element-type.enum';
import { FormV2ElementDto } from '../../shared/dto/form-v2-element.dto';
import { FormV2ResponseDto } from '../../shared/dto/form-v2-response.dto';
import { FormV2TemplateDto } from '../../shared/dto/form-v2-template.dto';
import { FormBuilderService } from '../../shared/service/form-builder.service';
import { FormResponseV2Service } from '../../shared/service/form-response-v2.service';

@Component({
  selector: 'wl-form-submission-view-modal',
  templateUrl: './form-submission-view-modal.component.html',
  styleUrls: ['./form-submission-view-modal.component.less'],
    standalone: false
})
export class FormSubmissionViewModalComponent implements OnInit {
  @Input() showSubmissionModal: boolean;
  @Input() submissionResponse: FormResponseDto<any>;
  @Input() formTemplate: FormV2TemplateDto;
  @Output() closeSubmissionModal: EventEmitter<boolean> = new EventEmitter<boolean>();
  socialMedias: Array<SocialMediaType>;
  elementType = FormV2ElementTypeEnum;
  profileLabels: { [key: string]: string };
  listingCategories: Array<ListingCategory>;
  listingSubCategories: Array<ListingSubCategory>;
  loading: boolean = false;
  isV2Form: boolean = false;

  constructor(
    private _formBuilderService: FormBuilderService,
    private _translationService: TranslationService,
    private _listingCategoryService: ListingCategoryService,
    private _listingSubCategoryService: ListingSubCategoryService,
    private _formResponseService: FormResponseV2Service
  ) {}

  async ngOnInit(): Promise<void> {
    let promiseArr = [];
    let listingSubCategorySearchParams = new ListingSubCategorySearchParams();
    let listingCategorySearchParams = new ListingCategorySearchParams();
    listingCategorySearchParams.PageSize = 0;
    listingSubCategorySearchParams.PageSize = 0;

    promiseArr.push(
      this._formBuilderService.getActiveSocialMediaTypes().then((data) => {
        this.socialMedias = data.Result;
      })
    );

    promiseArr.push(
      this._translationService
        .getAsObject('form-builder.form-submissions.form-submission-list.form-submission-view-modal.profile-labels')
        .then((result: { [key: string]: string }) => {
          this.profileLabels = result;
        })
    );

    promiseArr.push(
      this._listingCategoryService.search(listingCategorySearchParams).then((result) => {
        this.listingCategories = result?.Result;
      })
    );

    promiseArr.push(
      this._listingSubCategoryService.search(listingSubCategorySearchParams).then((result) => {
        this.listingSubCategories = result?.Result;
      })
    );
    await Promise.all(promiseArr);
  }

  open(uniqueId: string, isV2Form: boolean) {
    this.showSubmissionModal = true;
    this.loading = true;
    this.isV2Form = isV2Form;
    this._formResponseService.get(uniqueId).then((response) => {
      this.submissionResponse = response;
      this.loading = false;
    });
  }

  getSocialMediaLabel(socialMediaTypeID) {
    return this.socialMedias.find((socialMedia) => socialMedia.SocialMediaTypeID == socialMediaTypeID)?.Name;
  }

  getProfileLabel(profileLabelKey: string) {
    return this.profileLabels[profileLabelKey];
  }

  getCategoryValue(categoryID: number) {
    return this.listingCategories.find((category) => category.CategoryID === categoryID)?.Category;
  }

  getSubCategoryValue(subCategoryID: number) {
    return this.listingSubCategories.find((subCategory) => subCategory.SubCategoryID === subCategoryID)?.SubCategory;
  }

  getTemplateElement(response: FormV2ElementResponseDto): FormV2ElementDto {
    return this.formTemplate.FormElements.find((x) => x.Id == response.ElementId);
  }

  getMembershipLevel(element) {
    return element.MembershipLevelOptions.find((x) => x.MembershipLevelId === element.Value);
  }

  close() {
    this.submissionResponse = null;
    this.showSubmissionModal = false;
    this.closeSubmissionModal.emit(this.showSubmissionModal);
  }
}
